import script from "./TumorBoardCurrentSession.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoardCurrentSession.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoardCurrentSession.vue?vue&type=style&index=0&id=3a84b81c&scoped=true&lang=css"
import "./TumorBoardCurrentSession.vue?vue&type=style&index=1&id=3a84b81c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a84b81c"]])

export default __exports__